<template lang="pug">
  article.flex.flex-col.justify-between.min-h-screen
    section
      //- (password form)
      template(v-if="isPrivate")
        .pt-180.flex.justify-center(@submit.prevent="submitPwd")
          form
            label.reader-show.uppercase.text-13 Password
            input.block.border.border-black.text-16.text-center.p-2(type="password", required, placeholder="password", v-model="pwd", :class="{'border-dotted opacity-50': !submitting}", :disabled="submitting")
      //- (collection)
      template(v-else)
        .pt-180.text-center.text-16.p-2.animate-flash(v-show="loading") LOADING...
        //- (no collection)
        header.pt-120.md-px-90(v-if="comingSoon")
          h6.text-16.uppercase Coming Soon
        //- collections
        collection-feed(v-for="id in feeds", :id="id", :slug="slug", @loaded="loading = false")
    //- site footer
    app-footer
</template>

<script>
import CollectionFeed from '@/components/CollectionFeed'
import AppFooter from '@/components/AppFooter'
import get from 'lodash/get'
export default {
  name: 'Collection',
  props: ['slug', 'collections'],
  data () {
    return {
      doc: null,
      pwd: '',
      submitting: false,
      loading: false
    }
  },
  computed: {
    feeds () {
      const feeds = get(this.doc, 'acf.product_collections')
      return this.collections || (feeds && feeds.map(col => col.shopify_collection_id))
    },
    comingSoon () {
      return (this.doc || this.collections) && (this.feeds && !this.feeds.length)
    },
    isPrivate () {
      /*
       * Password-protected posts return empty [acf] data
      */
      return this.doc && this.doc.acf && !Object.keys(this.doc.acf).length
    }
  },
  methods: {
    getRack (params) {
      return this.$store.dispatch('getRack', params)
        .then(doc => {
          this.doc = doc
          // private page?
          // if (this.isPrivate) {
          //   const code = get(doc, 'acf.code')
          //   if (code !== this.$route.query.q) {
          //     // no code? redirect home
          //     return this.$router.replace({name: 'home'})
          //   } else {
          //     // strip code
          //     return this.$router.replace({query: {}})
          //   }
          // }
          /**
          Set a code for the private link, this code must be present in the URL to load the page. Otherwise the visitor will be redirected to the homepage — <i>ottolinger.com/collections/collection-name<b>?q=MYCODE</b></i>
          **/
        })
    },
    submitPwd () {
      this.submitting = true
      this.getRack({ slug: this.slug, pwd: this.pwd, refresh: true }).then(() => {
        console.log('fin')
        this.submitting = false
        if (!this.isPrivate) {
          this.loading = true
        }
      })
    }
  },
  created () {
    this.getRack({ slug: this.slug })
  },
  metaInfo () {
    if (!this.doc) return
    let meta = []
    // block search?
    // <meta name="robots" content="noindex, nofollow">
    // const isPrivate = get(this.doc, 'acf.visibility') === 'private'
    if (this.isPrivate) {
      meta.push({ name: 'robots', content: 'noindex, nofollow' })
    }
    return {
      title: this.doc.title.rendered,
      meta: meta
    }
  },
  components: { CollectionFeed, AppFooter }
}
</script>

<style>
@keyframes flash{
  0%{ opacity: 1; }
  50%{ opacity: 0.2; }
  100%{ opacity: 1; }
}
.animate-flash{
  animation:flash 2s infinite;
}
</style>
